import { render, staticRenderFns } from "./SFTPPdRes.vue?vue&type=template&id=418096e6&scoped=true&"
import script from "./SFTPPdRes.vue?vue&type=script&lang=js&"
export * from "./SFTPPdRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418096e6",
  null
  
)

export default component.exports